import { startOfMonth, endOfMonth, parse, format } from 'date-fns'

import type { SalesPeriod } from './SalesPeriod'

export const SalesPeriodMonth = {
  create(date: Date): SalesPeriod {
    return {
      start: startOfMonth(date),
      end: endOfMonth(date),
    }
  },

  parse(serialized: string) {
    return SalesPeriodMonth.create(parse(serialized, 'yyyy-MM', new Date()))
  },

  serialize({ start }: SalesPeriod) {
    return format(start, 'yyyy-MM')
  },

  toSalesPeriodInput({ start, end }: SalesPeriod) {
    return {
      startAt: format(start, 'yyyy-MM-dd'),
      endAt: format(end, 'yyyy-MM-dd'),
    }
  },
}
